/** Extract a user-facing message from an axios / NestJS error response. */
export const getApiErrorMessage = (
  error: any,
  fallback = "Something went wrong"
): string => {
  const data = error?.response?.data;
  const message = data?.message;

  if (Array.isArray(message) && message.length > 0) {
    return message.join(", ");
  }
  if (typeof message === "string" && message.trim()) {
    return message;
  }
  if (typeof data?.error === "string" && data.error.trim()) {
    return data.error;
  }
  if (typeof error?.message === "string" && error.message.trim()) {
    // Prefer backend message; avoid bare axios status text when possible
    if (
      error.message.startsWith("Request failed with status code") &&
      data
    ) {
      return fallback;
    }
    return error.message;
  }
  return fallback;
};
